// extracted by mini-css-extract-plugin
export default {"normVersion__headerCellBtn":"NewVersionTabTable_normVersion__headerCellBtn__28QOS"};